/** Intended destination after login (deep links / private routes / footer auth links). */
export const PENDING_NAVIGATION_KEY = "pendingNavigation";

export function setPendingNavigation(path: string): void {
  const trimmed = path.trim();
  if (!trimmed || trimmed === "/") return;
  sessionStorage.setItem(PENDING_NAVIGATION_KEY, trimmed);
}

export function peekPendingNavigation(): string | null {
  return sessionStorage.getItem(PENDING_NAVIGATION_KEY);
}

export function consumePendingNavigation(): string | null {
  const path = peekPendingNavigation();
  if (path) sessionStorage.removeItem(PENDING_NAVIGATION_KEY);
  return path;
}

export function clearPendingNavigation(): void {
  sessionStorage.removeItem(PENDING_NAVIGATION_KEY);
}

/** pathname + search + hash for the current location. */
export function locationToPendingPath(location: {
  pathname: string;
  search: string;
  hash: string;
}): string {
  return `${location.pathname}${location.search}${location.hash}`;
}
